import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import {
  ObjectiveSection,
  SectionTitle,
  SectionSubtitle,
  ObjectiveGrid,
  ObjectiveCard,
  ObjectiveIcon,
  ObjectiveTitle,
  ObjectiveDescription
} from './styles';

const Objective: React.FC = () => {
  const { language } = useLanguage();
  const objectives = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,2A7,7 0 0,0 5,9C5,11.38 6.19,13.47 8,14.74V17A1,1 0 0,0 9,18H15A1,1 0 0,0 16,17V14.74C17.81,13.47 19,11.38 19,9A7,7 0 0,0 12,2M9,21A1,1 0 0,0 10,22H14A1,1 0 0,0 15,21V20H9V21Z" />
        </svg>
      ),
      title: language === 'pt' ? 'Inovação' : 'Innovation',
      description: language === 'pt' 
        ? 'Buscamos constantemente novas tecnologias e abordagens para oferecer soluções que antecipam as necessidades do mercado.'
        : 'We constantly seek new technologies and approaches to offer solutions that anticipate market needs.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,5.5A3.5,3.5 0 0,1 15.5,9A3.5,3.5 0 0,1 12,12.5A3.5,3.5 0 0,1 8.5,9A3.5,3.5 0 0,1 12,5.5M5,8C5.56,8 6.08,8.15 6.53,8.42C6.38,9.85 6.8,11.27 7.66,12.38C7.16,13.34 6.16,14 5,14A3,3 0 0,1 2,11A3,3 0 0,1 5,8M19,8A3,3 0 0,1 22,11A3,3 0 0,1 19,14C17.84,14 16.84,13.34 16.34,12.38C17.2,11.27 17.62,9.85 17.47,8.42C17.92,8.15 18.44,8 19,8M5.5,18.25C5.5,16.18 8.41,14.5 12,14.5C15.59,14.5 18.5,16.18 18.5,18.25V20H5.5V18.25M0,20V18.5C0,17.11 1.89,15.94 4.45,15.6C3.86,16.28 3.5,17.22 3.5,18.25V20H0M24,20H20.5V18.25C20.5,17.22 20.14,16.28 19.55,15.6C22.11,15.94 24,17.11 24,18.5V20Z" />
        </svg>
      ),
      title: language === 'pt' ? 'Excelência' : 'Excellence',
      description: language === 'pt'
        ? 'Comprometemo-nos com os mais altos padrões de qualidade em todos os nossos produtos e serviços, superando expectativas.'
        : 'We commit to the highest quality standards in all our products and services, exceeding expectations.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" />
        </svg>
      ),
      title: language === 'pt' ? 'Confiança' : 'Trust',
      description: language === 'pt'
        ? 'Construímos relacionamentos sólidos com nossos clientes baseados em transparência, integridade e cumprimento de compromissos.'
        : 'We build solid relationships with our clients based on transparency, integrity, and commitment fulfillment.'
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,17V16H9V14H13V13H10A1,1 0 0,1 9,12V9A1,1 0 0,1 10,8H11V7H13V8H15V10H11V11H14A1,1 0 0,1 15,12V15A1,1 0 0,1 14,16H13V17H11Z" />
        </svg>
      ),
      title: language === 'pt' ? 'Resultados' : 'Results',
      description: language === 'pt'
        ? 'Focamos em entregar soluções que geram valor real e mensurável para nossos clientes, impulsionando seu sucesso.'
        : 'We focus on delivering solutions that generate real and measurable value for our clients, driving their success.'
    }
  ];

  return (
    <ObjectiveSection>
      <div className="container">
        <SectionTitle>{language === 'pt' ? 'NOSSOS VALORES' : 'OUR VALUES'}</SectionTitle>
        <SectionSubtitle>
          {language === 'pt' 
            ? 'Princípios que guiam nossa atuação e relacionamento com clientes'
            : 'Principles that guide our actions and relationships with clients'}
        </SectionSubtitle>
        <ObjectiveGrid>
          {objectives.map((objective, index) => (
            <ObjectiveCard key={index}>
              <ObjectiveIcon>{objective.icon}</ObjectiveIcon>
              <ObjectiveTitle>{objective.title}</ObjectiveTitle>
              <ObjectiveDescription>{objective.description}</ObjectiveDescription>
            </ObjectiveCard>
          ))}
        </ObjectiveGrid>
      </div>
    </ObjectiveSection>
  );
};

export default Objective;